import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "initials",
  standalone: false
})
export class InitialsPipe implements PipeTransform {
  transform(
    value: { firstName: string; lastName: string },
    options?: { fullLastname?: boolean }
  ): string {
    const initialFirstname = value.firstName?.slice(0, 1).toUpperCase() || "";

    if (options?.fullLastname) {
      return `${initialFirstname} ${value?.lastName || ""}`.toUpperCase();
    }

    return `${initialFirstname}${value?.lastName?.slice(0, 1) || ""}`.toUpperCase();
  }
}
